module.exports = __webpack_public_path__ + "static/img/calendar_simple.86d0516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar_simple.jpg
// module id = 5eqX
// module chunks = 1